import { SendOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useState } from 'react';
import { MessageFieldContainer } from './styled';
import useHandleUserMessage from '../hooks/useHandleUserMessage';

function MessageField({ disabled, getStream, style = {} }) {
  const [question, setQuestion] = useState('');
  const { submitQuestion } = useHandleUserMessage({ getStream });

  const handleQuestionChange = (event) => {
    setQuestion(event.target.value);
  };

  const handleQuestionSubmit = () => {
    if (disabled || !question) {
      return;
    }
    submitQuestion(question);
    setQuestion('');
  };

  return (
    <MessageFieldContainer style={style}>
      <Input
        placeholder="Enter Your Question"
        value={question}
        disabled={disabled}
        suffix={
          <SendOutlined
            style={{
              color: 'rgba(0,0,0,.45)',
              cursor: disabled || !question ? 'not-allowed' : 'pointer',
            }}
            onClick={handleQuestionSubmit}
          />
        }
        onChange={handleQuestionChange}
        onPressEnter={handleQuestionSubmit}
      />
    </MessageFieldContainer>
  );
}

export default MessageField;
